// extracted by mini-css-extract-plugin
export var pillar = "pillars-module--pillar--nNxZ2";
export var pillarsSVG = "pillars-module--pillarsSVG--JHBu5";
export var st01 = "pillars-module--st01--HPbGx";